<template>
    <main>
        <div class="container-fluid">
            <div class="mainButton">
                <div class="row">

                    <!-- breadcrumb start -->
                    <div class="col-10">
                        <ul class="nav_breadcrumbs">
                            <li>
                                <router-link to="/modules/home">Home</router-link>
                            </li>
                        </ul>
                    </div>
                    <!-- breadcrumb end -->


                    <!-- right side widget for enable and disaple to dashlet -->
                    <div class="col-2 text-end">
                        <div class="dashlet-home">
                            <div class="actionMore" v-on:click="isHidden = !isHidden">
                                <span></span><span></span><span></span>
                            </div>
                            <form @submit.prevent="saveWidgetList">
                                <div class="moreBox" v-if="isHidden">
                                    <div class="top p-2 text-start">All Widgets</div>
                                    <div class="content p-2">
                                        <div class="wedget-list">
                                            <div class="item" v-for="(widgetsList, index) in allWidgets" :key="index">
                                                <label>{{widgetsList.name}}</label>
                                                <div v-if="widgetsList.status==1" class="switch">
                                                    <input type="checkbox" v-model="widgetsList.status"
                                                        :id="widgetsList.id" checked>
                                                    <span class="slider round"></span>
                                                </div>
                                                <div v-else class="switch">
                                                    <input type="checkbox" v-model="widgetsList.status"
                                                        :id="widgetsList.id">
                                                    <span class="slider round"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bottom p-2">
                                        <template v-if="customLoading=='savewidgets'">
                                            <loader></loader>
                                        </template>
                                        <button v-else type="submit" class="btn btn-success btn-sm">Save</button>
                                        <button class="btn btn-warning btn-sm"
                                            v-on:click="isHidden = !isHidden">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- counter section start -->
            <div class="row">
                <template v-if="customLoading=='widgets'">
                    <loader></loader>
                </template>
                <template v-else>
                    <draggable group="counter" @start="drag=true" @end="saveDashletListOrder('.counterWidgetClass')"
                        class="col-sm-3 col-lg-3 col-md-6 col-sm-6 col-12"
                        v-for="(counterList, index) in counterWidgets" :key="index">
                        <DashletCounter :module="counterList.dashlet_module" :title="counterList.dashlet_title"
                            :folder="counterList.dashlet_folder" :udid="counterList.udid"
                            :updateWidgetsList="updateWidgetsList" class="counterWidgetClass">
                        </DashletCounter>
                    </draggable>
                </template>
            </div>
            <!-- counter section end -->

            <div class="row">

                <!-- table section start -->
                <div class="col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12">
                    <template v-if="customLoading=='widgets'">
                        <loader></loader>
                    </template>
                    <template v-else>
                        <draggable group="table" @end="saveDashletListOrder('.tableWidgetClass')"
                            v-for="(tableList, index) in tableWidgets" :key="index" :data-id="tableList.udid">
                            <DashletTable :module="tableList.dashlet_module" :title="tableList.dashlet_title"
                                :folder="tableList.dashlet_folder" :udid="tableList.udid"
                                :updateWidgetsList="updateWidgetsList" class="tableWidgetClass">
                            </DashletTable>
                        </draggable>
                    </template>
                </div>
                <!-- table section end -->

                <!-- chart section start -->
                <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
                    <template v-if="customLoading=='widgets'">
                        <loader></loader>
                    </template>
                    <template v-else>
                        <draggable group="chart" @start="drag=true" @end="saveDashletListOrder('.chartWidgetClass')"
                            v-for="(chartList, index) in chartWidgets" :key="index">
                            <DashletChart :module="chartList.dashlet_module" :title="chartList.dashlet_title"
                                :folder="chartList.dashlet_folder" :udid="chartList.udid"
                                :updateWidgetsList="updateWidgetsList" class="chartWidgetClass">
                            </DashletChart>
                        </draggable>
                    </template>
                    <!-- chart section end -->
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import { ref } from "vue";

    import DashletTable from "@/components/layout/shared/generic/dashlets/DashletTable.vue";
    import DashletGraph from "@/components/layout/shared/generic/dashlets/DashletGraph.vue";
    import DashletCounter from "@/components/layout/shared/generic/dashlets/DashletCounter.vue";
    import DashletChart from "@/components/layout/shared/generic/dashlets/DashletChart.vue";
    import loader from "@/views/shared/loading/Loading.vue";
    import DateFormat from "@/plugins/date_format.js";
    import draggable from 'vuedraggable'

    export default {
        name: "home",
        data() {
            return {
                isHidden: false,
                loading: false,
                currentUser: [],
                allWidgets: [],
                updateWidgets: {},
                tableWidgets: [],
                counterWidgets: [],
                chartWidgets: [],
                latestItem: [],
                dataList: {},
                opportunity_id: '',
                customLoading: false,
                user_type: false,
                series: [10, 20, 30, 40, 50],
                chartOptions: {
                    
                    dataLabels: {
                        enabled: false
                    },
                    labels: ['Apple', 'Mango', 'Orange', 'Watermelon']
                },
            }
        },
        components: { draggable, DashletTable, DashletCounter, DashletChart, loader, DashletGraph },

        mounted() {
            this.getWidgets();
            let user_prefrence = JSON.parse(localStorage.getItem('user_prefrence'));
            if (user_prefrence && user_prefrence.user_type) {
                this.user_type = user_prefrence.user_type;
            }
        },
        methods: {
            getWidgets() {
                const self = this;
                window.currentAction = 'list';
                axios.get('api/widgets/getwidgets').then(function (response) {
                    self.allWidgets = response.data;
                    self.showDashlets()
                })
            },
            updateWidgetsList() {
                const self = this;
                self.allWidgets = [];
                window.currentAction = 'list';
                axios.get('api/widgets/getwidgets').then(function (response) {
                    self.allWidgets = response.data;
                })
            },
            saveWidgetList() {
                const self = this;
                self.customLoading = 'savewidgets';
                // console.log(self.allWidgets);
                // return false;
                axios.post('api/widgets/updatewidgets', self.allWidgets).then(function (response) {
                    self.customLoading = false;
                    self.isHidden = false;
                    self.showDashlets();
                })
            },
            saveDashletListOrder(typeClass) {
                const self = this;
                const updatedOrder = [];
                //    const elements = document.querySelectorAll(typeClass);
                const elements = document.querySelectorAll(typeClass);
                // Loop through each element

                elements.forEach((element, index) => {
                    const idValue = element.querySelector('div').id;
                    updatedOrder.push({
                        sequence: index + 1,
                        id: idValue,
                    })
                });
                axios.post('api/widgets/update-dashlet-list-order', { sort_data: updatedOrder }).then(function (response) {
                    self.customLoading = false;
                })
            },
            showDashlets() {
                const self = this;
                self.tableWidgets = [];
                self.counterWidgets = [];
                self.chartWidgets = [];
                self.customLoading = 'widgets';
                window.currentAction = 'list';
                axios.get('api/widgets/showDashlets').then(function (response) {
                    const dashlets = response.data;
                    if (Array.isArray(dashlets.data)) {
                        dashlets.data.forEach((item) => {
                            const minfo = item.dashlet_module.split('_');
                            const udid = item.id;
                            const dashlet_module = minfo[0];
                            const dashlet_folder = minfo[1];
                            const dashlet_type = minfo[2];
                            const dashlet_title = item.name ?? '';
                            if (dashlet_type != '' && dashlet_type == 'table') {
                                self.tableWidgets.push({
                                    udid,
                                    dashlet_module,
                                    dashlet_title,
                                    dashlet_folder,
                                    dashlet_type
                                });
                            }
                            if (dashlet_type != '' && dashlet_type == 'counter') {
                                self.counterWidgets.push({
                                    udid,
                                    dashlet_module,
                                    dashlet_title,
                                    dashlet_folder,
                                    dashlet_type
                                });
                            }
                            if (dashlet_type != '' && dashlet_type == 'chart') {
                                self.chartWidgets.push({
                                    udid,
                                    dashlet_module,
                                    dashlet_title,
                                    dashlet_folder,
                                    dashlet_type
                                });
                            }
                        });
                    }
                    self.customLoading = false;
                });
            },

        }
    }
</script>